// extracted by mini-css-extract-plugin
module.exports = {"seats":"_1DPVzW2qy70m"};